export default __webpack_public_path__ + "static/media/day.a6c9e0ce.svg";